module.exports = __webpack_public_path__ + "files/55e2c70080d94f45681b5681f58c9ffd.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/travel_places-4.png
// module id = 517
// module chunks = 76